import SmartImg from './SmartImg.jsx';
import { CONTACT } from '../data/contact.js';
import { SITE_IMAGES } from '../data/siteImages.js';

export default function ContactSection({ titleTag: Title = 'h2' }) {
  return (
    <section id="contact" className="section contact">
      <div className="container contact-layout">
        <div className="contact-card">
          <Title>Get your free quote</Title>
          <p className="contact-note">
            We’re booking services now—call for a fast estimate or message us on Facebook. Same-day callbacks when we can.
          </p>
          <ul className="contact-list">
            <li>
              <span className="label">Business</span>
              <span className="value">{CONTACT.business}</span>
            </li>
            <li>
              <span className="label">Phone</span>
              <a className="value" href={`tel:${CONTACT.phoneTel}`}>
                {CONTACT.phoneDisplay}
              </a>
            </li>
            <li>
              <span className="label">Service area</span>
              <span className="value">{CONTACT.serviceArea}</span>
            </li>
            <li>
              <span className="label">Facebook</span>
              <a className="value" href={CONTACT.facebookUrl} target="_blank" rel="noopener noreferrer">
                ProScape on Facebook
              </a>
            </li>
          </ul>
        </div>
        <div className="contact-showcase">
          <div className="showcase-frame showcase-frame--info">
            <SmartImg
              src={SITE_IMAGES.proscapeInfo}
              alt="ProScape Outdoor Services — phone and service details"
              width={900}
              height={1200}
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
